export enum HistoryType {
    bets = 'bets',
    casinoPlays = 'casinoPlays',
    transactions = 'transactions',
    liveDealer = 'liveDealer',
    allTransactions = 'allTransactions',
}
